module.exports = __webpack_public_path__ + "img/chivas-bottle.0f4a3042.webp";